import { Button } from '@heroui/react';
import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <ShieldX size={64} className="text-danger" />
      <h1 className="text-2xl font-bold text-default-900">Access Denied</h1>
      <p className="text-default-500">You don't have permission to view this page.</p>
      <Button color="primary" onPress={() => navigate('/')}>Go to Dashboard</Button>
    </div>
  );
}
